import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";

@Component({
	selector: "caass-staff",
	templateUrl: "./staff.component.html",
})
export class StaffComponent implements OnInit {
	constructor(private router: Router, private activatedRoute: ActivatedRoute) {}
	stdID: any;

	public ShowSelector = true;

	ngOnInit() {
		var r = this.activatedRoute;
		while (r.firstChild) r = r.firstChild;

		if (r.snapshot.data["HideSelector"]) {
			this.ShowSelector = false;
		}

		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.pipe(map(() => this.activatedRoute))
			.pipe(
				map((route) => {
					while (route.firstChild) route = route.firstChild;
					return route;
				})
			)
			.pipe(filter((route) => route.outlet === "primary"))
			.pipe(mergeMap((route) => route.data))
			.subscribe((event) => {
				if (event["HideSelector"]) {
					this.ShowSelector = false;
				} else {
					this.ShowSelector = true;
				}
			});
	}
}
